import { GiftCardsGridContainer, GiftCardsGridItem } from './components';

export const GiftCardsGrid = {
  Container: GiftCardsGridContainer,
  Item: GiftCardsGridItem,
};
